module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-container"
  }, [_c('div', {
    staticClass: "video-wrapper"
  }, [_c('video', {
    ref: "videoPlayer",
    staticClass: "video-player",
    attrs: {
      "poster": _vm.poster.url,
      "autoplay": _vm.autoplay,
      "controls": "",
      "width": "1920",
      "height": "1080"
    },
    on: {
      "click": function($event) {
        _vm.playPauseVideo()
      }
    }
  }, [_vm._l((_vm.videoSources), function(video) {
    return [_c('source', {
      attrs: {
        "src": video.url,
        "type": ("video/" + (video.format))
      }
    })]
  }), _vm._v("\n      Your browser does not support HTML5 video.\n    ")], 2)]), _vm._v(" "), (!_vm.videoIsPlaying) ? _c('svg', {
    staticClass: "video-play-button",
    attrs: {
      "viewBox": "0 0 200 200",
      "alt": "Play video"
    },
    on: {
      "click": function($event) {
        _vm.playPauseVideo()
      }
    }
  }, [_c('circle', {
    attrs: {
      "cx": "100",
      "cy": "100",
      "r": "90",
      "fill": "none",
      "stroke-width": "15",
      "stroke": "#fff"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "points": "70, 55 70, 145 145, 100",
      "fill": "#fff"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.videoIsPlaying) ? _c('a', {
    staticClass: "v-more",
    attrs: {
      "href": "#video-article"
    }
  }, [_c('span'), _vm._v("read more")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ab38c94"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/Video.vue
// module id = 83
// module chunks = 0